import api from './index'

class RedeemService {
    fetchRedeem() {
        return api.get('/setting/website/redeem')
    }
    addRedeem(data) {
        return api.post('/setting/website/redeem', data)
    }
    editRedeem(data) {
        return api.patch('/setting/website/redeem', data)
    }
    deleteRedeem(id) {
        return api.delete(`/setting/website/redeem/${id}`)
    }
}

export default new RedeemService()